import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { NgClass } from '@angular/common';
import { LeakDetectionSoundSignalService } from '@app/main/leak-detection/services/leak-detection-sound-signal/leak-detection-sound-signal.service';

@Component({
  selector: 'gc-ld-logger-noise-sound-signal-load',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ld-logger-noise-sound-signal-load.component.html',
  styleUrl: './ld-logger-noise-sound-signal-load.component.scss',
  host: {
    class: 'flex items-center justify-center',
  },
  imports: [SvgIconComponent, NgClass],
})
export class LdLoggerNoiseSoundSignalLoadComponent {
  private soundSignalService = inject(LeakDetectionSoundSignalService);

  public styleClass = input<string>('');

  public soundSignalId = input.required<string | null>();
  public soundSignalUrl = input.required<string | null>();

  public showDownloadAlways = input<boolean>(false);
  public hideImg = input<boolean>(false);

  public iconData = computed(() => {
    const soundSignalUrl = this.soundSignalUrl();

    if (soundSignalUrl === null) {
      return {
        src: 'icons/png/icon-sound-signal-disabled.png',
        name: 'icon-sound-signal-disabled',
      };
    }

    return {
      src: 'icons/png/icon-sound-signal.png',
      name: 'icon-sound-signal',
    };
  });

  public download(event: Event) {
    event.stopPropagation();

    this.soundSignalService.download(this.soundSignalUrl(), this.soundSignalId());
  }
}
